// extracted by mini-css-extract-plugin
export default {"error-container":"wBjxGjns","errorContainer":"wBjxGjns","error":"CnzQxpS8","icon":"YM4hGa5S"};